module.exports = __webpack_public_path__ + "img/SKWINKELNetActieCampagneplanningE2A637.153df3a8.png";